import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, Layout, Table, Input, DatePicker
} from 'antd';

import ListAppsAction from './actions/action';
import moment from 'moment';

function ListApps() {
  const { Content } = Layout;
  const { Column } = Table;
  const { Search } = Input;
  const [logs, setLogs] = useState([]);
  const [dataSource, setdataSource] = useState(logs);
  const [keyword, setKeyword] = useState('');
  const [filter, setFilter] = useState({
    keyword: null,
    startDate: null,
    endDate: null
  });



  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value
    })
    ListAppsAction({ type: 'apps/log', params: { ...filter, keyword: value } }, sessionStorage.getItem('token')).then((res) => {
      setLogs(res)
      setdataSource(res)
    });
    // const filteredData = logs.filter(entry =>
    //   [entry.app_name, entry.username, entry.full_name, entry.date_time]
    //     .some(prop => prop.toLowerCase().includes(value.toLowerCase()))
    // );

    // setdataSource(filteredData);
  }
  const getLogs = () => {
    ListAppsAction({ type: 'apps/log', params: filter }, sessionStorage.getItem('token')).then((res) => {
      setLogs(res)
      setdataSource(res)
    });
  }

  const handleDateRange = (e) => {
    setFilter({
      ...filter,
      startDate: e ? moment(e[0]).format('YYYY-MM-DD') : null,
      endDate: e ? moment(e[1]).format('YYYY-MM-DD') : null
    });
    
    ListAppsAction({
      type: 'apps/log', params: {
        ...filter,
        startDate: e ? moment(e[0]).format('YYYY-MM-DD') : null,
        endDate: e ? moment(e[1]).format('YYYY-MM-DD') : null
      }
    }, sessionStorage.getItem('token')).then((res) => {
      setLogs(res)
      setdataSource(res)
    });
  }

  useEffect(() => {
    getLogs()
  }, []);

  return (
    <>
      <Content className="content m-0">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row style={{ marginBottom: '15px' }}>
                <Col span={24}>
                  <DatePicker.RangePicker onCalendarChange={handleDateRange} />
                  <Search placeholder="Search" onSearch={(value) => handleSearch(value)} style={{ width: 200, float: 'right' }} />
                </Col>
              </Row>
              <Table dataSource={dataSource} size="middle" pagination={{ pageSize: 10, total: dataSource.length }}>
                <Column title="Date" dataIndex="date_time" key="date_time" />
                <Column title="Applications" dataIndex="app_name" key="app_name" />
                <Column title="User Name" dataIndex="username" key="username" />
                <Column title="Full Name" dataIndex="full_name" key="full_name" />
              </Table>
            </Card>
          </Col>
        </Row>
      </Content>
    </>
  );
}

export default ListApps;
